import {
  Checkbox,
  Flex,
  FlexItem,
  InputNumber,
  Select,
  Text
} from 'mailup-web-components'
import { taskConditionsState } from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import { optionsEventFilterSelect } from './const'

const ApplyConditionsEventComponent = () => {
  const [
    { ApplyConditionsEvent, TaskApplyConditionsEvent },
    setTaskConditionsState
  ] = useRecoilState(taskConditionsState)
  const intl = useIntl()

  const onChangeApplyConditionsEvent = () => {
    setTaskConditionsState((prev) => ({
      ...prev,
      ApplyConditionsEvent: !prev.ApplyConditionsEvent,
      isDirty: true
    }))
  }

  const onChangeIdEventFilter = (val) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      TaskApplyConditionsEvent: {
        ...prev.TaskApplyConditionsEvent,
        IdEventFilter: val
      },
      isDirty: true
    }))
  }

  const handleDaysFromLastEvent = (val) => {
    if (val >= 0) {
      setTaskConditionsState((prev) => ({
        ...prev,
        TaskApplyConditionsEvent: {
          ...prev.TaskApplyConditionsEvent,
          DaysFromLastEvent: val
        },
        isDirty: true
      }))
    }
  }

  return (
    <>
      <Flex alignItems='center'>
        <Checkbox
          checked={ApplyConditionsEvent}
          onChange={onChangeApplyConditionsEvent}
          label={intl.formatMessage({
            id: 'Load.Task.ConditionsWhenLabelRecipients'
          })}
          data-mu-test='checkBox-ApplyConditionsEvent'
        />
        <FlexItem minWidth='250px' margin='0 8px'>
          <Select
            value={TaskApplyConditionsEvent.IdEventFilter}
            onChange={onChangeIdEventFilter}
            searchable={false}
            disabled={!ApplyConditionsEvent}
            options={optionsEventFilterSelect.map((m) => ({
              value: m.value,
              label: intl.formatMessage({ id: m.label })
            }))}
          />
        </FlexItem>

        <Text>
          {intl.formatMessage({ id: 'Load.Task.ConditionsWhenLabelFrom' })}
        </Text>
        <FlexItem width='70px' margin='0 8px'>
          <InputNumber
            min={0}
            value={TaskApplyConditionsEvent.DaysFromLastEvent}
            onChange={handleDaysFromLastEvent}
            data-mu-test='input-DaysFromLastEvent'
            disabled={!ApplyConditionsEvent}
          />
        </FlexItem>
        <Text>
          {intl.formatMessage({ id: 'Load.Task.ConditionsWhenLabelDays' })}
        </Text>
      </Flex>
    </>
  )
}

export default ApplyConditionsEventComponent
